import { styled } from '@mui/material/styles';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import SocialBtn from './SocialBtn';
import { DEFAULT_CAFE_IMG } from '../../../../utils/constant';

const CafeContainer = styled('div')({
  display: 'flex',
  marginBottom: '7px',
  padding: '8px 16px',
  borderLeft: '1px solid #AA9178',
  color: '#000000',
});

const CafeContentContainer = styled('div')({
  width: '65%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingLeft: '15px',
});

const AvatarImage = styled('img')({
  maxHeight: '74px',
  width: 'auto',
});

const SocialList = styled('ul')({
  display: 'flex',
  alignItems: 'center',
  listStyle: 'none',
  padding: '0',
  margin: '0',
});
const CafeTitle = styled('div')({
  color: '#000000',
  fontFamily: 'Raleway',
  fontWeight: '400',
  fontsize: '16px',
  lineHeight: '19px',
});
const ListItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  listStyle: 'none',
  fontFamily: 'Raleway',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '16px',
  '&:not(:last-child)': {
    marginRight: '12px',
  },
  '& button': {
    height: '18px',
    svg: {
      height: '18px',
      width: '18px',
    },
  },
});
const CafeLink = styled('a')({
  textDecoration: 'none',
  cursor: 'pointer',
  color: 'initial',
});

const RelatedCafe = ({ cafe }) => {
  const linkUrl = `/cafe/${cafe._id}`;
  const averageRatingList = cafe.cafeRatings.map((e) => e.ratingScore);
  let isEmpty = false;
  let averageRating = 0;
  if (averageRatingList.length !== 0) {
    const sum = averageRatingList.reduce((acc, value) => {
      return acc + value;
    }, 0);
    averageRating = (sum / averageRatingList.length).toFixed(1);
  } else {
    isEmpty = true;
  }
  const cafeImage = cafe.attachments.length != 0 ? cafe.attachments[0].url : DEFAULT_CAFE_IMG;

  return (
    <CafeLink href={linkUrl}>
      <CafeContainer>
        <AvatarImage src={cafeImage} />
        <CafeContentContainer>
          <CafeTitle href="#">{cafe.cafeName}</CafeTitle>
          <SocialList>
            <ListItem>
              <SocialBtn>
                <StarBorderIcon />
              </SocialBtn>
              {isEmpty ? 'No rating' : averageRating}
            </ListItem>
            <ListItem>
              <SocialBtn>
                <ThumbUpOffAltIcon />
              </SocialBtn>
              {cafe.likedUsers.length}
            </ListItem>
            <ListItem>
              <SocialBtn>
                <ImportContactsIcon />
              </SocialBtn>
              {cafe.followedUsers.length}
            </ListItem>
          </SocialList>
        </CafeContentContainer>
      </CafeContainer>
    </CafeLink>
  );
};

export default RelatedCafe;
